module.exports = __webpack_public_path__ + "static/img/9.66628e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/9.jpg
// module id = W2fP
// module chunks = 21